export enum ReportEnum {
  ORDERS = 'ORDERS',
  PAYMENTS = 'PAYMENTS',
  TRANSACTIONS = 'TRANSACTIONS',
  USERS = 'USERS'
}
